"use strict";const e={ARABIC:"Arabic",HEBREW:"Hebrew",ISO_8601:"ISO 8601",US:"US"},s={[e.US]:["en-CA","en-US","es-AR","es-BO","es-CL","es-CO","es-CR","es-DO","es-EC","es-GT","es-HN","es-MX","es-NI","es-PA","es-PE","es-PR","es-SV","es-VE","pt-BR"],[e.ARABIC]:["ar","ar-AE","ar-BH","ar-DZ","ar-EG","ar-IQ","ar-JO","ar-KW","ar-LY","ar-OM","ar-QA","ar-SA","ar-SD","ar-SY","ar-YE","dv","dv-MV","ps","ps-AR"],[e.HEBREW]:["he","he-IL"]},r=[...Array(7)].map(((e,s)=>s));exports.CALENDAR_TYPES=e,exports.CALENDAR_TYPE_LOCALES=s,exports.WEEKDAYS=r;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/ReactCalendar/shared/const.js
// module id = 345
// module chunks = 0